import { useContext } from 'react'
import { GeneralContext } from '../../context/GeneralContext/GeneralContext'
import logo from '../../assets/logo_mvv.png'
import Solve_PNG_White from '../../assets/Solve_PNG_White.png'
import Solve_PNG from '../../assets/Solve_PNG.png'

export function SL_PublicLayout({ children }) {
    const { mobile_mode } = useContext(GeneralContext)
    return (
        <div className="w-screen h-screen flex justify-between items-center">
            <div className="h-full bg-sl-gray-50 none justify-center items-center flex-[1] flex-col hidden smb:flex">
                <div className="flex justify-center items-center h-full">
                    <img src={logo} className="w-full max-w-[500px] min-w-[200px]" />
                </div>
                <div className="">
                    <img src={Solve_PNG} className="w-full max-w-[150px] min-w-[200px]" />
                </div>
            </div>

            <div className="h-full flex justify-center items-center flex-1 relative bg-primary-900 w-[50%]" style={{ boxShadow: !mobile_mode && '-5px 0px 13px 0px rgba(156,156,156,1)' }}>
                {/* Wave */}
                <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                    <defs>
                        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                    </defs>
                    <g className="parallax">
                        <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                        <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                        <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                        <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                    </g>
                </svg>

                <div className="w-full h-full flex flex-col justify-center">
                    {mobile_mode && (
                        <div className="w-full flex justify-center items-center">
                            <img src={Solve_PNG_White} className="max-w-[150px]" />
                        </div>
                    )}
                    <div className="h-[90%] flex items-center justify-center">{children}</div>
                </div>
            </div>
        </div>
    )
}
